Object.defineProperty(exports, "__esModule", { value: true });
const signalr_1 = require("@microsoft/signalr");
const tokenAuth_1 = require("@hendersonengineers/utils/tokenAuth");
const constants_1 = require("./constants");
class SignalRConnection {
    constructor(hubName) {
        this.connection = this.createHubConnection(hubName);
        this.numListeners = 0;
    }
    get canStop() {
        return this.numListeners === 0;
    }
    registerListener() {
        this.numListeners++;
    }
    unregisterListener() {
        this.numListeners--;
    }
    createHubConnection(hubName) {
        return new signalr_1.HubConnectionBuilder()
            .withUrl(`${constants_1.SIGNALR_URL}/hubs/${hubName}`, {
            accessTokenFactory: async () => {
                let accessToken = (0, tokenAuth_1.getAccessToken)();
                if (!accessToken) {
                    accessToken = await (0, tokenAuth_1.getNewAccessToken)(true);
                }
                return accessToken;
            }
        })
            .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: ({ elapsedMilliseconds, previousRetryCount }) => {
                console.log(previousRetryCount, elapsedMilliseconds);
                if (previousRetryCount === 0) {
                    return 1; // retry immediately after a disconnect
                }
                if (previousRetryCount > 0 && elapsedMilliseconds < 35000) {
                    return 3000; // if the initial retry attempt fails, retry every 3 seconds for the next 35 seconds
                }
                return 60000; // after the first 35 seconds, retry every minute until reconnected
            }
        })
            .withKeepAliveInterval(60000) // this should match KeepAliveInterval in the server config
            .withServerTimeout(120000) // this should match ClientTimeoutInterval in the server config
            .build();
    }
}
exports.default = SignalRConnection;
//# sourceMappingURL=SignalRConnection.js.map